import { Table } from 'antd'
import PropTypes from 'prop-types'
import './TableCommon.scss'

export const TableCommon = ({
	columns,
	dataSource,
	loading,
	pagination,
	rowKey,
	rowSelection,
	className,
	...rest
}) => {
	const tableClassName = ['table-common', className].filter(Boolean).join(' ')
	return (
		<Table
			rowClassName={
				rowSelection !== undefined
					? rowSelection
					: (_, index) =>
							index % 2 === 0
								? 'table-row-light'
								: 'table-row-dark'
			}
			className={tableClassName}
			rowSelection={rowSelection}
			columns={columns}
			dataSource={dataSource}
			loading={loading}
			pagination={pagination}
			rowKey={rowKey}
			{...rest}
		/>
	)
}

TableCommon.propTypes = {
	columns: PropTypes.array,
	dataSource: PropTypes.array,
	loading: PropTypes.bool,
	rowKey: PropTypes.any,
	rowSelection: PropTypes.any,
	pagination: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	rowClassName: PropTypes.string,
}
